export default {
  organCode: 'organCode',
  ticker: 'ticker',
  id: 'id',
  month: 'month',
  overvew: {
    listOverviewTable: {
      ticker: 'TICKER',
      roe: 'ROE(%)',
      roa: 'ROA(%)',
      pe: 'P/E',
      pb: 'P/B',
    },
  },
  value: {
    timeRange: 'TIME RANGE',
    stockePicks: 'STOCK PICKS',
    vnIndex: 'VN INDEX',
  },
  DEFAULT_INDUSTRY: 'industry',
};
